import React, { useState, useEffect } from 'react';
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from '../Utils/LoadingContext';

const EmployeeFloorWiseAllocation = () => {
    const [plantList, setPlantList] = useState([]);
    const [selectedPlant, setSelectedPlant] = useState('');
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');

    const [employees, setEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    // ✅ Floor / Line replace Shift for allocation
    const [floorwise, setFloorWise] = useState([]);
    const [linewise, setLineWise] = useState([]);
    const [selectedFloor, setSelectedFloor] = useState('');
    const [selectedLine, setSelectedLine] = useState('');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [historyEmpCode, setHistoryEmpCode] = useState('');
    const { setLoading } = useLoading();
    const empcode = localStorage.getItem('empcode');

    // ✅ search field
    const [searchCode, setSearchCode] = useState('');

    const [filters, setFilters] = useState({
        PlantName: "",
        DepartmentName: "",
        EmployeeCode: "",
        Mode: ""
    });

    useEffect(() => {
        loadPlants();
    }, []);

    const loadPlants = async () => {
        try {
            const plantRes = await EmployeeProcessService.getPlant(empcode);
            if (plantRes?.data?.statusCode === 200) {
                setPlantList(plantRes.data.result);
            }
        } catch (error) {
            console.error("Error loading plants:", error);
        }
    };

    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setSelectedPlant(plantId);

        setEmployees([]);
        setSelectedEmployees([]);
        setSelectAll(false);
        setDepartments([]);
        setSelectedDepartment('');

        // ✅ reset floor/line whenever plant changes
        setFloorWise([]);
        setLineWise([]);
        setSelectedFloor('');
        setSelectedLine('');

        if (!plantId) return;

        try {
            debugger;
            // ✅ Fetch departments bound to Plant + empcode
            const deptRes = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (deptRes.data.statusCode === 200) {
                setDepartments(deptRes.data.result);
            }

            // ✅ Fetch Floor Wise bound by plant
            const floorResponse = await EmployeeProcessService.getFloorWise(plantId);
            if (floorResponse.data.statusCode === 200) {
                setFloorWise(floorResponse.data.result);
            } else {
                setFloorWise([]);
            }

            // ✅ Fetch Line Wise bound by plant
            // const lineResponse = await EmployeeProcessService.getLineWise(plantId);
            // if (lineResponse.data.statusCode === 200) {
            //     setLineWise(lineResponse.data.result);
            // } else {
            //     setLineWise([]);
            // }
        } catch (error) {
            console.error("Failed to load plant data:", error);
            setDepartments([]);
            setFloorWise([]);
            setLineWise([]);
        }

        // ✅ Update filters
        setFilters(prev => ({ ...prev, PlantName: plantId }));
    };
const handleFloorChange = async (e) => {
    const floorId = e.target.value;

    setSelectedFloor(floorId);

    // Clear previously selected line
    setSelectedLine('');
    setLineWise([]);

    if (!floorId) {
        return;
    }

    try {
        console.log("Selected Floor ID:", floorId);

        // API receives FLOOR ID
        const lineResponse =
            await EmployeeProcessService.getLineWise(floorId);

        console.log("Line API Response:", lineResponse.data);

        if (lineResponse.data.statusCode === 200) {
            setLineWise(lineResponse.data.result || []);
        } else {
            setLineWise([]);
        }

    } catch (error) {
        console.error("Error loading lines:", error);
        setLineWise([]);
    }
};
    const handleDepartmentChange = (e) => {
        const deptId = e.target.value;
        setSelectedDepartment(deptId);
        setFilters(prev => ({ ...prev, DepartmentName: deptId }));
    };

    const handleShowHistory = async (empCode) => {
        try {
            debugger;
            setLoading(true);
            setHistoryEmpCode(empCode);
            const res = await EmployeeProcessService.getEmployeeFloor({
                ...filters,
                EmployeeCode: empCode || "",
                Mode: "FloorHistory"
            });

            if (res.data.statusCode === 200 && res.data.result.length > 0) {
                setHistoryData(res.data.result);
            } else {
                setHistoryData([]);
            }
            setShowHistory(true);
        } catch (error) {
            console.error("Error fetching Floor history:", error);
            alert("Failed to load Floor history.");
        } finally {
            setLoading(false);
        }
    };

    const handleLoadEmployees = async () => {
        if (!filters.PlantName) {
            alert("Please select  Plant .");
            return;
        }

        try {
            const res = await EmployeeProcessService.getEmployeeFloor({
                ...filters,
                EmployeeCode: searchCode || "",
                Mode: "FloorGet"
            });

            if (res.data.statusCode === 200) {
                setEmployees(res.data.result);
                setSelectedEmployees([]);
                setSelectAll(false);
            } else {
                setEmployees([]);
            }
        } catch (err) {
            console.error("Error loading employees:", err);
            setEmployees([]);
        }
    };

    const handleSelectEmployee = (employeeCode) => {
        if (selectedEmployees.includes(employeeCode)) {
            setSelectedEmployees(selectedEmployees.filter(code => code !== employeeCode));
        } else {
            setSelectedEmployees([...selectedEmployees, employeeCode]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(employees.map(emp => emp.empCode));
        }
        setSelectAll(!selectAll);
    };

    const handleSubmit = async () => {
        // ✅ Floor and Line are now required instead of Shift
        if (!selectedFloor || !selectedLine || !startDate || !endDate || selectedEmployees.length === 0) {
            alert("Please fill all required fields and select employees.");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                EmpCode: selectedEmployees.join(','),
                FloorID: selectedFloor,
                LineID: selectedLine,
                StartDate: startDate,
                EndDate: endDate
            };

            const res = await EmployeeProcessService.setEmployeeFloor(payload);
            if (res.success === true) {
                alert("Floor and Line assigned successfully.");
                 await handleLoadEmployees();   // reload table with updated data
                setSelectedEmployees([]);
                setSelectAll(false);
            } else {
                const message = res.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }
        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            alert(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <h4 className="text-primary mb-3">Floor and Line Allocation</h4>

            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="text-primary">Plant</label>
                    <select
                        className="form-select"
                        value={selectedPlant}
                        onChange={handlePlantChange}
                        required
                    >
                        <option value="">-- Select Plant --</option>
                        {plantList.map(plant => (
                            <option key={plant.id} value={plant.id}>{plant.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="text-primary">Department</label>
                    <select
                        className="form-select"
                        value={selectedDepartment}
                        onChange={handleDepartmentChange}
                        required
                    >
                        <option value="">-- Select Department --</option>
                        {departments.map(dept => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="text-primary"> Employee Code Comma Separeted</label>
                    <input
                        type="text"
                        className="form-control"
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                        placeholder="Enter Employee Code"
                    />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button
                        className="btn btn-primary"
                        onClick={handleLoadEmployees}
                    >
                        Load Employees
                    </button>
                </div>
            </div>

            {employees.length > 0 && (
                <>
                    <div style={{ overflowX: 'auto', maxHeight: '350px' }}>
                        <table className="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>User Code</th>
                                    <th>Name</th>
                                    <th>Department</th>
                                    <th>Default FloorName</th>
                                    <th>Default LineName</th>
                                    <th>Assigned FloorName</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employees.map(emp => (
                                    <tr key={emp.empCode}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedEmployees.includes(emp.empCode)}
                                                onChange={() => handleSelectEmployee(emp.empCode)}
                                            />
                                        </td>
                                        <td>{emp.empCode}</td>
                                        <td>{emp.empName}</td>
                                        <td>{emp.department}</td>
                                        <td>{emp.floorName}</td>
                                        <td>{emp.lineName  }</td>
                                        
                                        <td>
                                            <button
                                                className="btn btn-link p-0"
                                                onClick={() => handleShowHistory(emp.empCode)}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="row mb-3">
                     
                        <div className="col-md-3">
                            <label>Floor</label>
                            <select
                                className="form-select"
                                value={selectedFloor}
                               onChange={handleFloorChange}
                                required
                            >
                                <option value="">-- Select Floor --</option>
                                {floorwise.map(floor => (
                                    <option key={floor.id} value={floor.id}>{floor.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>Line</label>
                            <select
                                className="form-select"
                                value={selectedLine}
                                onChange={(e) => setSelectedLine(e.target.value)}
                                required
                            >
                                <option value="">-- Select Line --</option>
                                {linewise.map(line => (
                                    <option key={line.id} value={line.id}>{line.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>Floor Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <label>Floor End Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-end mt-2">
                            <button className="btn btn-success" onClick={handleSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>

                    {showHistory && (
                        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }}>
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title text-primary">
                                            Floor History - {historyEmpCode}
                                        </h5>
                                        <button type="button" className="btn-close" onClick={() => setShowHistory(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        {historyData.length > 0 ? (
                                            <table className="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Floor Name</th>
                                                        <th>Line Name</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {historyData.map((row) => (
                                                        <tr key={row.ID}>
                                                            <td>{row.floorName}</td>
                                                            <td>{row.lineName}</td>
                                                            <td>{row.startDate}</td>
                                                            <td>{row.endDate}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p>No Floor history found in the last 2 months.</p>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={() => setShowHistory(false)}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default EmployeeFloorWiseAllocation;
